import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { EventBusy } from '@mui/icons-material';
import { useUserWithProfileQuery } from '@uplift/queries';
import { Button } from '../../../Button';


const useStyles = makeStyles({ name: 'InCallNoUpcomingAppointments' })(theme => ({
  root: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    display: 'flex',
    fontSize: '44px',
    color: theme.palette.info.light,
  },
  title: {
    fontSize: '18px',
    fontWeight: 600,
  }
}));


export const InCallNoUpcomingSessions: React.VFC<{ patientId: string; onScheduleSession: () => void }> = ({ patientId, onScheduleSession }) => {
  const { classes } = useStyles();
  const { data: patient } = useUserWithProfileQuery(patientId, { suspense: true });

  return (
    <Box className={classes.root}>
      <Box>
        <EventBusy className={classes.icon} />
      </Box>
      <Box mt={2}>
        <Typography className={classes.title}>No upcoming sessions with {patient?.profile?.preferredName || patient?.user?.firstName}</Typography>
      </Box>
      <Box mt={3}>
        <Button color="secondary" variant="contained" onClick={onScheduleSession}>Schedule session</Button>
      </Box>
    </Box>
  );
};
